import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiBarChartModule } from '@components/ui-chart/bar/ui-bar-chart.module';
import { UiLineChartModule } from '@components/ui-chart/line/ui-line-chart.module';
import { UiPieChartModule } from '@components/ui-chart/pie/ui-pie-chart.module';
import { SharedModule } from '@modules/shared.module';
import { StatsPageComponent } from '@pages/stats/stats.page';
import { ChartColorService } from '@services';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        UiPieChartModule,
        UiLineChartModule,
        UiBarChartModule,
        A11yModule,
        UiNgLetModule,
        UiContentLoaderModule,
    ],
    providers: [
        ChartColorService,
    ],
    declarations: [
        StatsPageComponent,
    ],
    exports: [
        StatsPageComponent,
    ],
})
export class StatsModule { }
